<div class="external-refs-wrapper mb-10" [formGroup]="form">
    <label class="field-label">{{'Reference IDs' | translate}}</label>

    <div class="flex items-center justify-between mb-10">
        <button mat-stroked-button type="button" color="primary" (click)="addRow()">
            + {{'Add reference' | translate}}
        </button>
    </div>

    <div formArrayName="refs" *ngIf="rows.length > 0">
        <div class="ref-row grid grid-cols-12 gap-3 items-center" *ngFor="let row of rows; let i = index"
            [formGroupName]="i">

            <mat-form-field class="col-span-5 mp-field" appearance="fill">
                <mat-label>{{'Service name' | translate}}</mat-label>
                <mat-select formControlName="serviceName" >
                    <mat-option *ngFor="let s of serviceNames" [value]="s">{{ s }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="col-span-5 mp-field" appearance="fill">
                <mat-label>{{'Reference value' | translate}}</mat-label>
                <input matInput formControlName="serviceValue" placeholder="e.g. customer-id-123"/>
            </mat-form-field>

            <div class="col-span-1 flex items-center justify-end mp-remove">
                <button mat-icon-button color="warn" type="button" (click)="removeRow(i)">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>